import isSameDay from 'date-fns/isSameDay'
export default function(data = [], label) {
  const retData = []
  for (const key in label) {
    let val = 0
    data.forEach((el) => {
      const date1 = new Date(label[key])
      const date2 = new Date(el.x)
      if (isSameDay(date2, date1)) {
        val = el.y
      }
    })
    retData.push({ x: label[key], y: val })
  }
  return retData
}
